import Menu from './Compartido/Menu.jsx';
import TextosEdificio from './Edificio/TextosEdificio.jsx';
import PropiedadesEdificio from './Edificio/PropiedadesEdificio.jsx';
import Footer from './Compartido/Footer.jsx';

const Edificio = (props) => {

    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosEdificio
                texto={props.eledificio}
                ruta={props.ruta}
                lang={props.lang}
            />
            <PropiedadesEdificio
                propiedades={props.eledificio.propiedades}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Edificio;
